export default "/assets/ico-search.png";